import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  CheckCircledIcon,
  CrossCircledIcon,
  HomeIcon,
  Pencil1Icon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { NavLink } from "react-router-dom";
import {
  checkTagValidity,
  getUserProfil,
  months,
  userToken,
  years,
} from "../../Utils/Utils";
import {
  BASE_URL,
  EN_ATTENTE_TEST,
  EXPORT_RAPPORT,
  LIST_TEST,
} from "../../Utils/constant";
import { UpdateTest } from "../../components/Ajouter-intention/UpdateTest";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { Tabs } from "../../components/Widget/Tab";
import { useCommentaireStore } from "../../store/CommentaireStore";
import { useStoreLivraison } from "../../store/livraisonStore";
import { useStoreApp } from "../../store/storeApp";
const TestSouscription = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [numeroTicket, setNumeroTicket] = useState(null);
  const [select, setSelect] = useState("ANNEE");
  const [active, setActive] = useState({
    index: 0,
    value: "En attente d'identification",
  });
  const [page, setPage] = useState(0);

  const more = (page) => {
    setPage(page - 1);
    listTests.getData(
      LIST_TEST,
      { page: page - 1, param: "", size: 10 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=&status=&resultat=",
    );
  };

  const moreEnAttente = (page) => {
    enAttentTest.getData(
      EN_ATTENTE_TEST,
      { page: page - 1, param: "", size: 10 },
      "&dateDebut=&dateFin=&inTime=",
    );
  };

  const listTests = useStoreLivraison();
  const enAttentTest = useStoreApp();
  const commentaire = useCommentaireStore();

  const listeTabsData = [
    {
      index: 0,
      value: "En attente de test",
      tag: "LISTE_EN_ATTENTE_TEST",
    },
    {
      index: 1,
      value: "Testé",
      tag: "LISTE_TEST",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
  }, []);

  useEffect(() => {
    listTests.getData(
      LIST_TEST,
      { page: 0, param: "", size: 10 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&status=&resultat=OK&inTime=`,
    );
    commentaire.getData("page=0&param=&size=10000000");
    enAttentTest.getData(
      EN_ATTENTE_TEST,
      { page: 0, param: "", size: 10 },
      "&dateDebut=&dateFin=&inTime=",
    );
  }, []);

  const handleDownload = () => {
    const user = getUserProfil();
    fetch(
      `${BASE_URL + EXPORT_RAPPORT}?model=TESTS&username=${user?.username}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken()}`,
        },
        body: JSON.stringify({}),
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `RAPPORT_TESTS.xlsx`; // spécifiez le nom du fichier et son extension
        document.body.appendChild(a);
        a.click();
      })
      .catch((err) => console.error("Erreur de téléchargement:", err));
  };

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center">
        <h3 class="text-3xl font-bold font-mtn">Test de connectivité</h3>
        <div className="ml-auto lg:flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select onChange={(e) => {}} className="my-2 select">
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select onChange={(e) => {}} className="my-2 select ">
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>

      {filteredTabsData.length !== 0 ? (
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
      ) : null}

      <div className="bg-white rounded-md px-2 py-4 mt-3">
        {active && active.tag === "LISTE_EN_ATTENTE_TEST" ? (
          <>
            <div className="mt-3 lg:flex gap-1 items-center">
              <input
                onChange={(e) => {
                  enAttentTest.getData(
                    EN_ATTENTE_TEST,
                    { page: 0, param: e.target.value, size: 10 },
                    "&dateDebut=&dateFin=&inTime=",
                  );
                }}
                type="text"
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-500 placeholder:text-gray-500"
              />
              <select
                onChange={(e) =>
                  enAttentTest.getData(
                    EN_ATTENTE_TEST,
                    { page: 0, param: "", size: 10 },
                    `&dateDebut=&dateFin=&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>

              {active.index === 1 ? (
                <>
                  <select
                    onChange={(e) => {
                      listTests.getData(
                        LIST_TEST,
                        { page: 0, param: "", size: 10 },
                        `&periode=&mois=&annee=&dateDebut=&dateFin=&status=&resultat=${e.target.value}`,
                      );
                    }}
                    className="select"
                  >
                    <option disabled>Resultat</option>
                    <option value="OK" selected>
                      OK
                    </option>
                    <option value="NON_OK">Non OK</option>
                  </select>
                </>
              ) : null}
            </div>

            <div className=" grid  lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
              {enAttentTest?.data?.data?.length === 0 ? (
                <div className="">
                  <p className="text-sm ">Aucune donnée </p>
                </div>
              ) : enAttentTest?.data?.data?.length !== 0 &&
                !enAttentTest?.loading ? (
                enAttentTest?.data?.data?.map((item) => (
                  <div
                    className={`${
                      item?.statusSuppression === "EN_ATTENTE" && "opacity-30"
                    } relative bg-white rounded-xl border-slate-200 border shadow-md`}
                  >
                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        N° {item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                      <div className="ml-auto flex items-center gap-2">
                        <div
                          className={` px-1 border  rounded-full py-[2px] text-xs ${
                            item?.abonnement?.statusConfirmation === "CONFIRMER"
                              ? "text-green-600"
                              : "text-gray-500"
                          }  font-semibold`}
                        >
                          {item?.abonnement?.statusConfirmation?.toLowerCase()}
                        </div>
                      </div>
                    </div>
                    <div className=" px-3 py-2 ">
                      <div className="items-center gap-2 space-y-3">
                        <Periode item={item} />
                        {/* <p className="mb-2  text-gray-500 text-xs font-medium">{new Date(item?.abonnement.dateCreation).toLocaleString()}</p> */}
                        <Pbo
                          pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                          port={item?.brin}
                        />
                        <div className="flex gap-1 my-3">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>
                                {item?.abonnement.client?.secondNumero}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>
                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            {/* <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p> */}
                          </div>
                        </div>
                        <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <CalendarIcon />
                            {item?.dateRdv +
                              (item?.crenau
                                ? " de " +
                                  item?.crenau?.heureDebut +
                                  " à " +
                                  item?.crenau?.heureFin
                                : "")}
                          </p>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation}
                        </h1>

                        <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <HomeIcon />
                            {item?.abonnement?.batiment?.designation}
                          </p>
                          <p className="text-xs flex gap-1 font-medium">
                            <ArchiveIcon />{" "}
                            {item?.abonnement?.equipement?.designation}{" "}
                          </p>
                        </div>
                      </div>
                      <h1 className="my-2 text-[13px] font-medium flex items-center">
                        <SewingPinFilledIcon />
                        {item?.abonnement?.commune +
                          ", " +
                          item?.abonnement?.quartier}
                      </h1>
                      <div className="flex items-center gap-1">
                        <h5 className="text-xs font-medium ">Etape:</h5>
                        <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                          {item?.abonnement?.status
                            ?.toLowerCase()
                            .replace(/_/g, " ")}
                        </p>
                      </div>

                      {checkTagValidity("POURSUIVRE_TEST") &&
                      item?.statusSuppression !== "EN_ATTENTE" ? (
                        <NavLink
                          className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                          to={`poursuivre-intention/${item?.abonnement?.eligibilite?.numeroTicket}/8`}
                        >
                          Poursuivre
                        </NavLink>
                      ) : null}
                    </div>
                  </div>
                ))
              ) : (
                <ContentLoading />
              )}
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => moreEnAttente(newValue)}
                onSelect={(selectedPage) => moreEnAttente(selectedPage)}
                count={enAttentTest?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : active && active.tag === "LISTE_TEST" ? (
          <>
            <div className="mt-3 lg:flex gap-1 items-center">
              <input
                onChange={(e) => {
                  listTests.getData(
                    LIST_TEST,
                    { page: 0, param: e.target.value, size: 10 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&status=&resultat=OK&inTime=`,
                  );
                }}
                type="text"
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-500 placeholder:text-gray-500"
              />

              {active.index === 1 ? (
                <>
                  <select
                    onChange={(e) => {
                      listTests.getData(
                        LIST_TEST,
                        { page: 0, param: "", size: 10 },
                        `&periode=&mois=&annee=&dateDebut=&dateFin=&status=&resultat=${e.target.value}`,
                      );
                    }}
                    className="select"
                  >
                    <option disabled>Resultat</option>
                    <option value="OK" selected>
                      OK
                    </option>
                    <option value="NON_OK">Non OK</option>
                  </select>
                  <select
                    onChange={(e) =>
                      listTests.getData(
                        LIST_TEST,
                        { page: 0, param: "", size: 10 },
                        `&periode=&mois=&annee=&dateDebut=&dateFin=&status=&resultat=OK&inTime=${e.target.value}`,
                      )
                    }
                    className="select pl-non my-3"
                  >
                    <option disabled selected>
                      Delais de traitement
                    </option>
                    <option value="">Tout afficher</option>
                    <option value={"true"}>Intention dans le delais</option>
                    <option value={"false"}>Intention hors delais</option>
                  </select>
                </>
              ) : null}
            </div>
            <div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-4">
                {listTests?.data?.data?.length === 0 ? (
                  <div className="flex justify-center items-center">
                    <p>Aucune donnée</p>
                  </div>
                ) : listTests?.data?.data?.length !== 0 &&
                  !listTests?.loading ? (
                  listTests?.data?.data?.map((item) => (
                    <div
                      className={`${
                        !item?.inTime
                          ? "border-red-300 border-2 border-dashed"
                          : "border-slate-200 border"
                      } relative bg-white rounded-xl  shadow-sm`}
                    >
                      <div className="rounded-t-xl flex items-center gap-3 border-b-[2px] border-orange-100 px-4 py-3">
                        <p className="text-[12px] font-semibold">
                          Ticket N°
                          {item?.abonnement?.eligibilite?.numeroTicket}{" "}
                        </p>
                        <p className="text-red-500 text-xs">
                          {!item?.inTime ? "Hors delais" : ""}
                        </p>
                      </div>
                      <div className="px-3 py-2">
                        <div
                          className={`flex gap-2 px-3 border w-fit rounded-full py-1 text-xs text-green-600 font-semibold`}
                        >
                          {item?.status?.toLowerCase()}
                          {item.resultat === "OK" ? (
                            <CheckCircledIcon className="ml-auto bg-green-600 w-4 h-4 rounded-full text-white" />
                          ) : item.resultat === "NON_OK" ? (
                            <CrossCircledIcon className="bg-red-600 w-4 h-4 rounded-full text-white" />
                          ) : null}
                        </div>
                        <div className="my-1 flex items-center">
                          <div className="flex items-center gap-2">
                            <Pbo
                              pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                              port={item?.brin}
                            />
                          </div>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            {/* <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p> */}
                          </div>
                        </div>

                        <div className="items-center gap-2 space-y-3">
                          <h1 className="text-xs flex items-center my-2">
                            <SewingPinFilledIcon />
                            Lieu de raccordement :{" "}
                            {item?.abonnement?.commune +
                              ", " +
                              item?.abonnement?.quartier}
                          </h1>
                          <div className="pb-3 border-b gap-4 items-center">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon /> Date de test :
                              {" " + item?.dateH
                                ? new Date(item?.dateH).toLocaleString()
                                : "--"}
                            </p>
                            <div className="mt-2 flex items-center">
                              <p className="text-xs font-medium text-blue-700">
                                Commentaire: {item?.commentaire}{" "}
                              </p>
                            </div>

                            <div className="mt-2 flex items-center gap-2 border-t pt-3">
                              <p className="text-xs font-medium text-black">
                                Debit de la connexion:{" "}
                                {item?.debitConstate + "M/s"}{" "}
                              </p>
                            </div>
                          </div>

                          <div className="flex gap-1 ">
                            <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                            <div>
                              <p className="text-[13px] font-medium">
                                {item?.abonnement.client?.nomPrenoms}
                              </p>
                              <p className="text-xs flex font-semibold gap-2">
                                <span>{item?.abonnement.client?.numero}</span>{" "}
                                {" | "}{" "}
                                <span>
                                  {item?.abonnement.client?.email}
                                </span>{" "}
                              </p>
                            </div>
                          </div>

                          {item.resultat === "OK" ? null : checkTagValidity(
                              "MODIFIER_TEST",
                            ) ? (
                            <button
                              onClick={() => {
                                setNumeroTicket(
                                  item?.abonnement?.eligibilite?.numeroTicket,
                                );
                                document.getElementById("edit").showModal();
                              }}
                              className="ml-auto text-white text-xs btn btn-sm bg-black"
                            >
                              <Pencil1Icon /> Modifier
                            </button>
                          ) : null}

                          <button
                            onClick={() => {
                              document
                                .getElementById(`show${item.id}`)
                                .showModal();
                            }}
                            className="btn btn-sm bg-main text-xs"
                          >
                            Details de test
                          </button>

                          <dialog
                            id={`show${item.id}`}
                            className="modal bg-slate-900/70"
                          >
                            <div className="modal-box relative">
                              <div className="absolute top-2 right-4 ">
                                <form method="dialog">
                                  <button
                                    id="fermer_create_trajet"
                                    className="w-8 h-8 flex items-center justify-center  font-semibold"
                                  >
                                    ✕
                                  </button>
                                </form>
                              </div>
                              <div>
                                <div className="">
                                  <div className="bg-white p-3 rounded-lg">
                                    <div className="">
                                      <h3 className="font-mtn lg:text-lg text-2xl text-amber-500 font-bold">
                                        Ticket N°
                                        {
                                          item?.abonnement?.eligibilite
                                            ?.numeroTicket
                                        }
                                      </h3>
                                    </div>
                                    <div className="mt-3 border-t border-dashed border-amber-300">
                                      <dl className="divide-y divide-gray-100">
                                        <div className="py-3 ">
                                          <dt className="text-sm text-gray-500">
                                            Client
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6  ">
                                            {
                                              item?.abonnement?.client
                                                ?.nomPrenoms
                                            }
                                          </dd>
                                        </div>

                                        <div className="py-3">
                                          <dt className="text-sm leading-6 text-gray-500">
                                            Email
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6  ">
                                            {item?.abonnement?.client?.email}
                                          </dd>
                                        </div>
                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Contact client
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 ">
                                            {item?.abonnement?.client?.numero}
                                          </dd>
                                        </div>
                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Numero avantage
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 ">
                                            {item?.abonnement?.numeroMtn}
                                          </dd>
                                        </div>
                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Ville du client
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 ">
                                            {
                                              item?.abonnement?.domicile
                                                ?.quartier?.commune?.designation
                                            }
                                          </dd>
                                        </div>
                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Quartier
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6">
                                            {
                                              item?.abonnement?.domicile
                                                ?.quartier?.designation
                                            }
                                          </dd>
                                        </div>

                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Status d'éligibilité
                                          </dt>
                                          <dd className="mt-1 text-sm leading-6 font-medium text-amber-600 ">
                                            {item?.abonnement?.eligibilite
                                              ?.ftthEligible === "yes"
                                              ? "Eligible"
                                              : "Pas eligible"}
                                          </dd>
                                        </div>

                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Forfait souhaité
                                          </dt>
                                          <dd className="mt-1 text-sm leading-6 text-amber-500 ">
                                            {
                                              item?.abonnement?.forfait
                                                ?.designation
                                            }
                                          </dd>
                                        </div>
                                      </dl>
                                    </div>
                                  </div>
                                </div>
                                <div className="">
                                  <p className="p-3 font-bold text-lg font-mtn text-amber-600">
                                    Information sur le test
                                  </p>
                                  <div className="bg-white p-3 rounded-lg">
                                    <div className="">
                                      <dl className="divide-y divide-gray-100">
                                        <div className="py-3 ">
                                          <dt className="text-sm  text-gray-500">
                                            Commentaire
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                            {item.commentaire ?? "--"}
                                          </dd>
                                        </div>

                                        <div className="py-3 ">
                                          <dt className="text-sm  text-gray-500">
                                            Date de réalisation
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                            {item?.dateH
                                              ? new Date(
                                                  item?.dateH,
                                                ).toLocaleString()
                                              : "--"}
                                          </dd>
                                        </div>

                                        <div className="py-3 ">
                                          <dt className="text-sm  text-gray-500">
                                            Status du test
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                            {item?.status?.toLocaleLowerCase() ??
                                              "--"}
                                          </dd>
                                        </div>

                                        <div className="py-3 ">
                                          <dt className="text-sm  text-gray-500">
                                            Status de réalisation
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                            {item?.resultat.replace("_", " ") ??
                                              "--"}
                                          </dd>
                                        </div>

                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Debit Constaté
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                            {item?.debitConstate ?? "--"} Mb/s
                                          </dd>
                                        </div>
                                        <div className="py-3 ">
                                          <dt className="text-sm  leading-6 text-gray-500">
                                            Réalisé par
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-900 ">
                                            {item?.agent?.nomPrenoms ?? "--"}
                                          </dd>
                                        </div>
                                      </dl>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </dialog>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <ContentLoading />
                )}
              </div>
              <dialog id="edit" className="modal ">
                <div className="modal-box w-10/12 max-w-2xl">
                  <div className="modal-action">
                    <h1 className="mr-auto text-2xl font-bold font-mtn">
                      Test de connectivité
                    </h1>
                    <form method="dialog">
                      <button
                        id="fermer"
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>
                  <UpdateTest numeroTicket={numeroTicket} />
                </div>
              </dialog>
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={listTests?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default TestSouscription;
